
const GenerateHTML = ({ order, transformedData }) => {
  return new Promise((resolve) => {

    const displayStyle = order?.code_discount || order?.wallet_amount_used ? 'flex' : 'none';
    const calculatePayablePrice = (order) => {
      const totalPrice = parseFloat(order?.total_price) || 0;
      const walletAmount = parseFloat(order?.wallet_amount_used) || 0;
      const couponDiscount = parseFloat(order?.code_discount) || 0;

      return (totalPrice - walletAmount - couponDiscount).toFixed(2);
    };


    const tempDiv = document.createElement("div");
    tempDiv.innerHTML = `
        <!DOCTYPE html>
<html lang="en">
<head>
  <meta name="viewport" content="width=device-width, initial-scale=1.0">
  <style>
 @media print {
      body {
        margin: 0 !important;
        padding: 0 !important;
        font-size: 9px !important;
        line-height: 1.2 !important;
      }

      .card {
        padding: 3px !important;
        margin: 2px 0 !important;
        box-shadow: none !important;
      }

      .phone-image {
        width: 50px !important;
        height: 50px !important;
      }

      .footer {
        margin-top: 5px !important;
        padding: 0 !important;
      }

      /* Prevent unexpected breaks */
      .card:last-child {
        page-break-after: never !important;
      }
    }
      * {
    background-color: transparent !important;
}

    body { 
      font-family: 'Arial', sans-serif; 
      background-color: #fff;
      padding: 10px;
      max-width: 800px;
      margin: 0 auto;
      color: #333;
    }

    .card {
      background: #fff;
      padding: 15px;
      border-radius: 10px;
      box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
      margin-bottom: 15px;
    }

    .company-header {
      text-align: center;
      margin-bottom: 20px;
    }

    .company-name {
      font-size: 22px;
      font-weight: bold;
      color: #007bff;
    }

    .company-motto {
      color: #666;
      font-style: italic;
      font-size: 14px;
    }

    .repair-text {
      font-size: 20px;
      font-weight: bold;
      color: #333;
    }

    .order-id {
      color: #666;
      font-size: 14px;
    }

    .dashed-line, .solid-line {
      border-top: 1px dashed #ccc;
      margin: 10px 0;
    }

    .solid-line {
      border-top: 1px solid #ccc;
    }

    .device-section {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 10px 0;
    }

    .device-info {
      margin-bottom: 5px;
    }

    .date-text {
      color: #777;
      font-size: 14px;
    }

    .device-name {
      font-weight: bold;
      font-size: 16px;
      color: #333;
    }

    .color-text {
      color: #777;
      font-size: 14px;
    }

    .phone-image {
      width: 80px;
      height: 80px;
      object-fit: contain;
      border-radius: 8px;
      border: 1px solid #ddd;
      padding: 5px;
    }

    .repairs-list {
      margin: 10px 0;
      padding-left: 20px;
    }

    .repair-item {
      margin: 5px 0;
      color: #444;
      font-size: 14px;
    }

    .price-row {
      display: flex;
      justify-content: space-between;
      padding: 8px 0;
      font-size: 14px;
    }

    .total-price {
      font-weight: bold;
      font-size: 16px;
      color: #007bff;
      padding-top: 10px;
      border-top: 2px solid #e0e0e0;
    }

    .coupon-discount, .wallet-amount, .payable-price {
      display: none;
      justify-content: space-between;
      padding: 8px 0;
    }

    .payable-price {
      font-weight: bold;
      color: #28a745;
    }

    .contact-info {
      margin: 10px 0;
    }

    .label {
      font-weight: bold;
      color: #333;
      font-size: 14px;
    }

    .value {
      color: #555;
      font-size: 14px;
    }

    .footer {
      text-align: center;
      margin-top: 20px;
      padding-top: 15px;
      border-top: 1px solid #e0e0e0;
      color: #666;
      font-size: 12px;
    }
  </style>
</head>
<body>

  <div class="company-header">
    <div class="company-name">At Your Door Mobile Repair Service</div>
    <div class="company-motto">Professional Repairs, Exceptional Service</div>
  </div>

  <!-- Repair Details Card -->
  <div class="card">
    <div class="repair-text">Repair Details</div>
    <div class="order-id">Order ID: ${order.order_id}</div>
    <div class="dashed-line"></div>

    ${transformedData
      .map(
        (data) => `
          <div>
            <div class="device-section" style="background-color:#fff">
              <div class="device-info">
                <div class="date-text">${order.create_date}</div>
                <div class="device-name">${data.phone}</div>
                <div class="color-text">Genuine</div>
                
              </div>
              <img src="${data.url}" class="phone-image" alt="${data.phone}" />
            </div>

            <div class="label">Booked Repairs:</div>
            <div class="repairs-list">
              ${data.products
                .map(
                  (product) => `<div class="repair-item">${product.product_name}</div>`
                )
                .join("")}
            </div>
            <div class="solid-line"></div>
          </div>
        `
      )
      .join("")}
  </div>

  <!-- Price Summary Card -->
  <div class="card">
    <div class="label" style="font-size: 16px;">Price Summary</div>
    <div class="dashed-line"></div>

    ${transformedData
      .map(
        (data) => `
          ${data.products
            .map(
              (product) => `
              <div class="price-row">
                <span>${product.product_name}</span>
                <span>₹${product.price}</span>
              </div>
            `
            )
            .join("")}
        `
      )
      .join("")}

    <div class="price-row total-price">
      <span>Total Price</span>
      <span>₹${order.total_price}</span>
    </div>

    ${order?.code_discount ? `
      <div class="coupon-discount" style="display: flex;">
        <span>Coupon Discount</span>
        <span>₹-${order.code_discount}</span>
      </div>
    ` : ''}

    ${order?.wallet_amount_used ? `
      <div class="wallet-amount" style="display: flex;">
        <span>Wallet Amount Used</span>
        <span>₹-${order.wallet_amount_used}</span>
      </div>
    ` : ''}

    ${(order?.code_discount || order?.wallet_amount_used) ? `
      <div class="payable-price" style="display: flex;">
        <span>Payable Amount</span>
        <span>₹${calculatePayablePrice(order)}</span>
      </div>
    ` : ''}
  </div>

  <!-- Contact Card -->
  <div class="card">
    <div class="contact-info">
      <div class="label">Payment Method</div>
      <div class="value">${order.payment_method === "cash" ? "Cash on Repair" : "Paid Online"}</div>
    </div>

    ${order.agent_no ? `
      <div class="contact-info">
        <div class="label">Agent Contact</div>
        <div class="value">${order.agent_no}</div>
      </div>
    ` : ''}

    <div class="contact-info">
      <div class="label">Delivery Address</div>
      <div class="value">${JSON.parse(order.address).address}</div>
    </div>

    <div class="contact-info">
      <div class="label">Customer Contact</div>
      <div class="value">${order.cust_contact}</div>
    </div>
  </div>

 <div class="footer">
  <p>Thank you for choosing our service!</p>
  <p>For queries, contact our support team.</p>
  <p>Generated on: ${new Date().toLocaleDateString()}</p>
</div>

</body>
</html>

    `;


    document.body.appendChild(tempDiv);

    setTimeout(() => {
      const options = {
        margin: [3, 3, 3, 3], 
        filename: `Invoice_${order.order_id}.pdf`,
        image: { type: 'jpeg', quality: 0.98 },
        html2canvas: { 
          scale: 2,
          useCORS: true,
          scrollY: 0,  
          windowHeight: document.documentElement.offsetHeight ,
          logging: false 
        },
        jsPDF: { 
          unit: 'mm',
          format: 'a4',
          orientation: 'portrait',
          precision: 96,
          compress: true
        }
      };

      window.html2pdf()
        .set(options)
        .from(tempDiv)
        .save()
        .then(() => {
          document.body.removeChild(tempDiv);
          resolve();
        });
    }, 500); 
  });
};

export default GenerateHTML;
